import { Currency } from "@redotech/money/currencies";
import { CompensationMethod } from "@redotech/redo-model/return";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const ReturnProductInfoSchema_ = z.object({
  productId: z.string(),
  productTitle: z.string(),
  aiReturnReasonSummary: z.string().optional(),
  compensationMethod: createEnum(CompensationMethod),
});

const HighLevelProductInfoSchema_ = z.object({
  productId: z.string(),
  productTitle: z.string(),
  price: z.string(),
  productImage: z.string().optional(),
});

const ReturnInsightInfoSchema_ = z.object({
  returnId: zExt.objectId(),
  orderName: z.string(),
  refundTypes: z.array(createEnum(CompensationMethod)),
  customerFirstName: z.string(),
  customerLastName: z.string(),
  createdAt: z.date(),
  numberOfItems: z.number(),
  products: z.array(ReturnProductInfoSchema_),
  totalRefund: z.number(),
  totalStoreCredit: z.number(),
  totalExchange: z.number(),
});

const GetReturnsInsightInfoOutputSchema_ = z.object({
  returns: z.array(ReturnInsightInfoSchema_),
  highLevelProductInfos: z.array(HighLevelProductInfoSchema_),
  currency: createEnum(Currency),
});

export const getReturnsInsightInfo = {
  name: "getReturnsInsightInfo" as const,
  input: z.object({
    returnIds: z.array(zExt.objectId()),
    productIds: z.array(z.string()),
  }),
  output: GetReturnsInsightInfoOutputSchema_,
};

export interface ReturnInsightInfo
  extends z.infer<typeof ReturnInsightInfoSchema_> {}

export interface HighLevelProductInfo
  extends z.infer<typeof HighLevelProductInfoSchema_> {}

export interface GetReturnsInsightInfoOutput
  extends z.infer<typeof GetReturnsInsightInfoOutputSchema_> {}
